import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class SupplyService {
  constructor(private http: HttpClient) {}

  getAllSupplyWithCount(data: any): Observable<any> {
    return this.http.post(environment.getAllSupplyWithCount, data);
  }
  addSupply(data: any): Observable<any> {
    return this.http.post(environment.addSupply, data);
  }
  updateSupply(data: any): Observable<any> {
    return this.http.post(environment.updateSupply, data);
  }
  deleteSupply(data: any): Observable<any> {
    return this.http.post(environment.deleteSupply, data);
  }
}
